import { render, staticRenderFns } from "./IconDetail.vue?vue&type=template&id=27b03faa&scoped=true"
import script from "./IconDetail.vue?vue&type=script&lang=js"
export * from "./IconDetail.vue?vue&type=script&lang=js"
import style0 from "./IconDetail.vue?vue&type=style&index=0&id=27b03faa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b03faa",
  null
  
)

export default component.exports